const featureFlags = {
  logging: {
    // Global logging.
    global: !import.meta.env.PROD,

    // Per-feature logging.
    payloadApiCollections: true,
    payloadApiUsers: true,
    payloadApiStripe: true,
    auth: true,
  },
};

export default featureFlags;
